<template>
  <div>
    <div
      v-if="card"
    >
      <card-viewer
        :card="card"
        show-fixture
        :is-removable="isRemovable"
        :show-score="showScore"
        :show-splitted-score="showSplittedScore"
        :show-average-score="showAverageScore"
        :is-clickable="isPickable"
        :is-captain="isCaptain"
        :is-captainable="isCaptainable"
        :width="width"
        :is-error="isError"
        @cardClicked="openCardPick"
        @captainSelected="captainSelected($event)"
        @removeCard="$emit('removeCard')"
      />
    </div>
    <div
      v-else-if="isPickable"
    >
      <v-btn
        :width="width"
        :height="height"
        color="#3E4456"
        class="card-picker"
        @click.stop="openCardPick"
      >
        <font-awesome-icon
          :icon="['fas', 'plus']"
          size="2x"
        />
      </v-btn>
    </div>
    <div
      v-else
    >
      {{ $t('card_picker.no_card_picked') }}
    </div>
  </div>
</template>

<script>
import CardViewer from '@/components/Card/CardViewer.vue';
import CardModel from '@/models/Card/card';

export default {
  name: 'CardPicker',
  components: {
    CardViewer,
  },
  props: {
    card: {
      type: CardModel,
      default: null,
    },
    fixture: {
      type: String,
      default: null,
    },
    showScore: {
      type: Boolean,
      default: false,
    },
    showSplittedScore: {
      type: Boolean,
      default: false,
    },
    showAverageScore: {
      type: Boolean,
      default: false,
    },
    isPickable: {
      type: Boolean,
      default: true,
    },
    isCaptain: {
      type: Boolean,
      default: false,
    },
    isCaptainable: {
      type: Boolean,
      default: false,
    },
    isEquippable: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '200px',
    },
    isError : {
      type : Boolean,
      default : false,
    },
    isRemovable : {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    height() {
      const width = parseInt(this.width.split('px')[0], 10);

      return `${width * 1.628}px`;
    },
  },
  methods: {
    openCardPick() {
      this.$emit('openCardPick');
    },
    captainSelected(cardSlug) {
      this.$emit('captainSelected', cardSlug);
    },
  },
};
</script>

<style scoped>
.card-picker {
  border: 3px solid #68708D !important;
  color:#68708D !important;
  font-size: 30px !important;
  border-radius: 10px !important;
  margin: 12px 18px;
}
</style>
